export default function MiniBar({ data, colors, height = 60 }) {
    if (!data?.length) return null;
    const max = Math.max(...data.map(d => d.v)) || 1;
    return (
      <div className="minibar" style={{ height }}>
        {data.map((d, i) => (
          <div key={i} className="minibar__item">
            <div className="minibar__bar" style={{ 
              height: `${Math.max((d.v / max) * (height - 20), 4)}px`, 
              backgroundColor: colors[i % colors.length] 
            }} />
            <span className="minibar__label">{d.l}</span>
          </div>
        ))}
      </div>
    );
  }